var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Media-Info Page"},[_c('div',{staticClass:"Page-Content Media-Info-Content"},[_c('h2',[_vm._v("3 app logos and accounts")]),_c('img',{attrs:{"src":require("@/assets/btn/Facebook.png"),"alt":""}}),_c('img',{attrs:{"src":require("@/assets/btn/Instagram.jpg"),"alt":""}}),_c('img',{attrs:{"src":require("@/assets/btn/TikTok.jpg"),"alt":""}})])])
}]

export { render, staticRenderFns }